import { ConfirmModal } from '../modals';
import { Button } from '../buttons';

import type { IModalToggle } from '../../hooks';
import { useContext, type FC } from 'react';
import { Localization } from '../../config/localization/localization';
import { LanguageSelectorContext } from '../../context/LanguageSelectorContext';

interface IPanelButtonsProps {
    isSaveDisabled?: boolean;
    isSaving: boolean;
    modalToggle: IModalToggle;
    onConfirm: () => void;
    onUpdate: () => Promise<void>;
    panelToggle: IModalToggle;
}

export const PanelButtons: FC<IPanelButtonsProps> = ({
    isSaveDisabled,
    isSaving,
    modalToggle,
    onConfirm,
    onUpdate,
    panelToggle,
}) => {
    const { selectedLanguage } = useContext(LanguageSelectorContext);
    const localization = new Localization(selectedLanguage);

    return (
        <div>
            <div
                className={
                    'float-right flex flex-shrink-0 flex-col-reverse items-center justify-between px-4 py-4 xxs:flex-row xxs:items-start'
                }
            >
                <div className={'space-x-3 py-1 xxs:py-0'}>
                    <Button buttonProps={{ onPress: panelToggle.close }} variant={'outline'}>
                        {localization.translate('actions.cancel')}
                    </Button>
                    <Button buttonProps={{ isDisabled: isSaveDisabled, onPress: onConfirm }}>{localization.translate('actions.update')}</Button>
                </div>
            </div>

            {/* CONFIRM UPDATE */}
            <ConfirmModal
                message={localization.translate('updateContactInfo.confirmationMessage')}
                modalToggle={modalToggle}
                onConfirm={onUpdate}
                isLoading={isSaving}
                isStatic
                title={localization.translate('updateContactInfo.confirmationTitle')}
            />
        </div>
    );
};